/**
 * 점주 콘솔 v2 회원 API.
 * master는 현재 선택한 storeId를 같이 보내고, manager는 backend가 본인 storeId로 강제한다.
 */
import api from '../../api/client';

export async function fetchOwnerMembers(params = {}) {
  const res = await api.get('/owner-console/members', { params });
  return res.data;
}

export async function fetchOwnerMemberDetail(memberId, params = {}) {
  const res = await api.get(`/owner-console/members/${memberId}`, { params });
  return res.data;
}

export async function fetchOwnerMemberContact(memberId, params = {}) {
  const res = await api.get(`/owner-console/members/${memberId}/contact`, {
    params,
  });
  return res.data;
}

/** 대시보드 요약 (first-party 건수). master는 선택 storeId 동봉. */
export async function fetchOwnerDashboard(params = {}) {
  const res = await api.get('/owner-console/dashboard', { params });
  return res.data;
}

/** 개인정보 열람 감사 로그 (master 전용). */
export async function fetchOwnerAuditLogs(params = {}) {
  const res = await api.get('/owner-console/audit-logs', { params });
  return res.data;
}

/**
 * 결제 실패 안내 문자 — dry-run 미리보기. 실제 발송 없음.
 * 응답: { action(mode), template, totalRecipients, undeliverable, onCooldown, sendable, recipients }
 */
export async function fetchPaymentFailedSmsPreview(params = {}) {
  const res = await api.get('/owner-console/actions/payment-failed-sms/preview', {
    params,
  });
  return res.data;
}

/** 액션 실행 원장 (master 전용) — 누가 언제 어떤 액션을 미리보기/발송했나 */
export async function fetchOwnerActionLogs(params = {}) {
  const res = await api.get('/owner-console/actions/logs', { params });
  return res.data;
}
